<template>
  <component :is="tag || 'div'" ref="el">
    <slot v-if="isVisible || forceVisible"></slot>
    <q-skeleton v-else height="400px" square />
  </component>
</template>

<script lang="ts">
export default {
  name: 'LazyWrapper',
  props: {
    tag: {
      type: String,
      required: false,
      default: undefined
    },
    forceVisible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      observer: null as IntersectionObserver | null
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true
          this.observer?.disconnect() // Stop observing once it's visible
        }
      },
      {
        rootMargin: '200px 0px' // Trigger 200px before entering viewport
      }
    )
    this.observer.observe(this.$refs.el as HTMLElement)
  },
  unmounted() {
    if (this.observer) this.observer.disconnect()
  }
}
</script>
